import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle';

import ScrollUpButton from '../Buttons/ScrollUpButton';

import withComponentName from '../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class StoryCaughtUp extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    autoBind(this);
    this.storyCaughtRef = createRef();
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { hideButton } = this.props;
    if (hideButton) return;

    const isInView = this.isInViewport();
    // This will find main scroll up button
    // starting of ID is generated by the react_component() by ruby and used it for search
    const mainScrollUpButtom = document.querySelector('[id^="ScrollUpButton-react-component-"]');
    if (isInView) {
      mainScrollUpButtom.style.display = 'none';
    } else {
      mainScrollUpButtom.style.display = 'block';
    }
  }

  isInViewport() {
    const element = this.storyCaughtRef.current;
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0
      && rect.left >= 0
      && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  render() {
    const { className, hideButton, hideText } = this.props;
    const storyCaughtClass = cx('story_caught_up', className);

    return (
      <div className={storyCaughtClass} ref={this.storyCaughtRef}>
        <div className={cx('caught_up_box', { hide: hideText })}>
          <FontAwesomeIcon icon={faCheckCircle} />
          <div className={Styles.caught_up_text}>You&apos;re all caught up</div>
        </div>
        <ScrollUpButton className={cx('caught_up_scroll', { hide: hideButton })} />
      </div>
    );
  }
}

StoryCaughtUp.propTypes = {
  className: PropTypes.string,
  hideButton: PropTypes.bool,
  hideText: PropTypes.bool,
};

StoryCaughtUp.defaultProps = {
  className: '',
  hideButton: false,
  hideText: false,
};

export default withComponentName(StoryCaughtUp);
